// import React from "react";
// import { containerSpecs } from "./containerdata";
// import "./cardgrid.css";

// const ContainerSpec = () => {
//   return (
//     <div
//       style={{
//         backgroundImage: "url('bgcon.webp')",
//         backgroundSize: "cover",
//         backgroundPosition: "center",
//         backgroundRepeat: "no-repeat",
//         backgroundAttachment: "fixed",
//         width: "99vw",
//         minHeight: "100vh",
//       }}
//     >
//       <div className="grid-container">
//         <h2 className="title" style={{ color: "#ffffffff" }}>
//           Container Specifications
//         </h2>
//         <div className="card-grid">
//           {containerSpecs.map((spec, index) => (
//             <div className="card" key={index}>
//               <img src={spec.image} alt={spec.title} className="card-img" />
//               <h3 className="card-title">{spec.title}</h3>
//               <div className="card-details">
//                 {spec.details.map((item, i) => (
//                   <p key={i} className="mb-1 leading-snug">
//                     <span className="icon">
//                       {React.createElement(item.icon)}
//                     </span>
//                     <strong>{item.label}:</strong> {item.value}
//                   </p>
//                 ))}
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ContainerSpec;

import React from "react";
import { containerSpecs } from "./containerdata";
import "./cardgrid.css";

const ContainerSpec = () => {
  return (
    <div
      style={{
        backgroundImage: "url('bgcon.webp')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "fixed",
        minHeight: "100vh",
        width: "100%",
        overflowX: "hidden",
      }}
    >
      <div className="grid-container">
        <h2 className="title" style={{ color: "#ffffffff" }}>
          Container Specifications
        </h2>
        <div className="card-grid">
          {containerSpecs.map((spec, index) => (
            <div className="card" key={index}>
              <img src={spec.image} alt={spec.title} className="card-img" />
              <h3 className="card-title">{spec.title}</h3>
              <div className="card-details">
                {spec.details.map((item, i) => (
                  <p key={i} className="mb-1 leading-snug">
                    <span className="icon">
                      {React.createElement(item.icon)}
                    </span>
                    <strong>{item.label}:</strong> {item.value}
                  </p>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ContainerSpec;
